/* Nirole cart drawer: reward ladder + cross-category suggestions with in-cart variant choice.
   Depends on nirole-cart-data.js (window.NiroleCartData) and the Impulse theme's
   'cart:updated' / 'cart:build' events. Purely additive - if anything here throws,
   the theme's own drawer keeps working. */
(function () {
  'use strict';

  var D = window.NiroleCartData;
  if (!D) return;

  var ROTATE_MS = 4000;
  var TAG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#fff" d="M21.4 11.6 12.4 2.6A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7c0 .5.2 1 .6 1.4l9 9a2 2 0 0 0 2.8 0l7-7a2 2 0 0 0 0-2.8ZM6.5 8A1.5 1.5 0 1 1 8 6.5 1.5 1.5 0 0 1 6.5 8Z"/></svg>';

  var rewardEl, suggestEl;
  var list = [], idx = 0, timer = null, manual = false;
  var sel = [];                 // chosen option values for the visible suggestion
  var cache = {};               // handle -> live product JSON
  var busy = false;

  /* ---------------------------------------------------------------- utils */
  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    return '£' + (cents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function getProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(theme.routes.home.replace(/\/$/, '') + '/products/' + handle + '.js',
      { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) cache[handle] = p; return p; });
  }

  /* ------------------------------------------------------- reward ladder */
  function nextTier(total) {
    for (var i = 0; i < D.tiers.length; i++) if (total < D.tiers[i].min) return D.tiers[i];
    return null;
  }
  // markers sit at even thirds; the fill interpolates inside the current segment
  function fillPct(total) {
    var seg = 100 / D.tiers.length, lo = 0;
    for (var i = 0; i < D.tiers.length; i++) {
      if (total < D.tiers[i].min) return seg * i + (total - lo) / (D.tiers[i].min - lo) * seg;
      lo = D.tiers[i].min;
    }
    return 100;
  }
  // the theme prints a plain translated 'Cart'; append the live count to it.
  // idempotent - the base word is cached so repeated renders never stack '(1)(1)'.
  function renderTitle(cart) {
    var el = document.querySelector('#CartDrawer .drawer__title');
    if (!el) return;
    var base = el.getAttribute('data-base');
    if (!base) {
      base = el.textContent.replace(/s*(d+)s*$/, '').trim();
      el.setAttribute('data-base', base);
    }
    el.textContent = base + ' (' + (cart.item_count || 0) + ')';
    // footer wording + trust strip, added once
    var sub = document.querySelector('#CartDrawer .ajaxcart__subtotal');
    if (sub && sub.textContent.trim() !== 'Total') sub.textContent = 'Total';
    var ship = document.querySelector('#CartDrawer .drawer__footer .cart__item-row.text-center small');
    if (ship && ship.textContent.indexOf('Free delivery') === -1) {
      ship.textContent = 'Free delivery on every order · taxes included';
    }
    var wrap = document.querySelector('#CartDrawer .cart__checkout-wrapper');
    if (wrap && !wrap.querySelector('.nirole-trust')) {
      var strip = document.createElement('div');
      strip.className = 'nirole-trust';
      strip.innerHTML = '<span>Secure checkout</span><span>30-day returns</span><span>UK support</span>';
      wrap.appendChild(strip);
    }
    var lbl = document.querySelector('#CartDrawer .drawer__close-button .icon__fallback-text');
    if (lbl && lbl.textContent.trim() !== 'Close') lbl.textContent = 'Close';
  }

  function renderReward(cart) {
    if (!rewardEl) return;
    if (!cart.item_count) { rewardEl.hidden = true; return; }
    rewardEl.hidden = false;

    // Shopify evaluates the discount minimum on the subtotal BEFORE the order discount.
    // cart.total_price is AFTER it, so using that would make the bar tell a shopper who
    // already earned 10% that they are still short of it.
    var total = (cart.items_subtotal_price != null ? cart.items_subtotal_price
                 : cart.original_total_price != null ? cart.original_total_price
                 : cart.total_price);
    var tg = nextTier(total), seg = 100 / D.tiers.length;
    var msg = !tg
      ? "You've unlocked <b>" + D.tiers[D.tiers.length - 1].pct + '% off</b> - our biggest saving.'
      : '<b>Add one more product</b> below and take <b>' + tg.pct + '% off</b> your order.';

    var steps = '', labs = '';
    D.tiers.forEach(function (t, i) {
      var left = seg * (i + 1), on = total >= t.min ? ' is-on' : '';
      var shift = i === D.tiers.length - 1 ? -85 : -50;
      steps += '<span class="nrw__step' + on + '" style="left:' + left + '%">' + TAG + '</span>';
      labs += '<span class="nrw__lab' + on + '" style="left:' + left + '%;transform:translateX(' +
              shift + '%)">Save<br>' + t.pct + '%</span>';
    });

    rewardEl.innerHTML =
      '<p class="nrw__msg">' + msg + '</p>' +
      '<div class="nrw__wrap"><div class="nrw__track">' +
        '<div class="nrw__fill" style="width:' + fillPct(total).toFixed(1) + '%"></div>' + steps +
      '</div><div class="nrw__labs">' + labs + '</div></div>';
  }

  /* ---------------------------------------------------------- suggestions */
  // different body area to everything in the cart, priced in band, stepping up,
  // with the two proven sellers seeded so they always get a showing
  function choose(cart) {
    var areas = {}, have = {};
    (cart.items || []).forEach(function (i) {
      have[i.handle] = 1;
      var a = D.area[i.handle];
      if (a) areas[a] = 1;
    });
    var sub = (cart.items_subtotal_price != null ? cart.items_subtotal_price
                 : cart.original_total_price != null ? cart.original_total_price : cart.total_price);
    var tg = nextTier(sub);
    var needed = tg ? (tg.min - sub) / 100 : 0;   // pounds this product must be worth

    // 3 option dropdowns make the suggestion card too tall, so those products are
    // never offered. 'o' is the option count stamped into the pool by the data file.
    var base = D.pool.filter(function (p) { return !areas[p.a] && !have[p.h] && (p.o == null || p.o <= 2); });
    if (!base.length) return [];
    // only offer things that genuinely take them over the line - otherwise
    // 'add one more product and take 10% off' would be a promise we cannot keep
    var pool = base.filter(function (p) { return p.p >= needed; });
    if (pool.length < 1) pool = base;

    var byArea = {};
    pool.slice().sort(function (a, b) {
      return (b.b - a.b) || (a.p - b.p) || (a.n - b.n);
    }).forEach(function (p) { if (!byArea[p.a]) byArea[p.a] = p; });

    var reps = Object.keys(byArea).map(function (k) { return byArea[k]; })
                     .sort(function (a, b) { return a.p - b.p; });

    var picked = reps.filter(function (p) { return p.b; }).slice(0, 3);
    for (var i = 0; i < reps.length && picked.length < 3; i++) {
      var p = reps[i];
      var clash = picked.some(function (x) { return x.h === p.h || x.a === p.a; });
      if (!clash) picked.push(p);
    }
    if (picked.length < 3) {
      var extra = {};
      base.slice().sort(function (a, b) { return b.p - a.p; }).forEach(function (p) {
        if (!extra[p.a]) extra[p.a] = p;
      });
      Object.keys(extra).forEach(function (k) {
        var p = extra[k];
        if (picked.length >= 3) return;
        if (picked.some(function (x) { return x.h === p.h || x.a === p.a; })) return;
        picked.push(p);
      });
    }
    return picked.sort(function (a, b) { return a.p - b.p; });
  }

  function variantOf(prod, chosen) {
    if (!prod.variants || !prod.variants.length) return null;
    var hit = null;
    prod.variants.forEach(function (v) {
      if (hit) return;
      var ok = true;
      (prod.options || []).forEach(function (o, i) {
        if (chosen[i] && v.options[i] !== chosen[i]) ok = false;
      });
      if (ok) hit = v;
    });
    return hit || prod.variants[0];
  }
  function realOptions(prod) {
    // Shopify represents "no options" as a single option named Title / Default Title
    if (!prod.options || prod.options.length === 0) return [];
    if (prod.variants.length === 1 && /default title/i.test(prod.variants[0].title)) return [];
    return prod.options.map(function (o) {
      return typeof o === 'string' ? { name: o, values: [] } : o;
    });
  }

  function renderSuggest() {
    if (!suggestEl) return;
    if (!list.length) { suggestEl.hidden = true; stop(); return; }

    var entry = list[idx];
    getProduct(entry.h).then(function (prod) {
      if (!prod) { suggestEl.hidden = true; return; }
      suggestEl.hidden = false;

      var opts = realOptions(prod);
      if (!sel.length) sel = opts.map(function (o) { return o.values[0]; });
      var v = variantOf(prod, sel);
      // the chosen variant carries its own photo when one is assigned on the
      // product - fall back to the product image only when it does not
      var img = (v && v.featured_image && v.featured_image.src)
        ? v.featured_image.src
        : (prod.featured_image || (prod.images && prod.images[0]) || '');
      if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2');

      var pickers = !opts.length ? '' :
        '<div class="nsg__vsel">' + opts.map(function (o, i) {
          return '<label><select data-opt="' + i + '">' + o.values.map(function (val) {
            return '<option value="' + esc(val) + '"' + (sel[i] === val ? ' selected' : '') + '>' +
                   esc(o.name + ': ' + val) + '</option>';
          }).join('') + '</select></label>';
        }).join('') + '</div>';

      var dots = list.length < 2 ? '' :
        '<div class="nsg__dots">' + list.map(function (_, i) {
          return '<button type="button" class="' + (i === idx ? 'is-on' : '') + '" data-dot="' + i +
                 '" aria-label="Suggestion ' + (i + 1) + '"></button>';
        }).join('') + '</div>';

      suggestEl.innerHTML =
        '<div class="nsg__card' + (busy ? ' is-busy' : '') + '">' +
          '<div class="nsg__ph"><img src="' + esc(img) + '" alt="" loading="lazy"></div>' +
          '<div class="nsg__m">' +
            '<p class="nsg__t">Want to add <span class="nsg__name">' + esc(prod.title) + '</span>?</p>' +
            pickers +
            '<div class="nsg__row"><span class="nsg__p">' + money(v ? v.price : prod.price) + '</span>' +
            '<button type="button" class="nsg__btn" data-variant="' + (v ? v.id : '') + '">Add to Cart</button>' +
            '</div>' +
          '</div>' +
        '</div>' + dots;
    });
  }

  /* ------------------------------------------------------------- rotation */
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function start() {
    stop();
    if (manual || list.length < 2 || !suggestEl || suggestEl.hidden) return;
    timer = setInterval(function () {
      idx = (idx + 1) % list.length;
      sel = [];
      renderSuggest();
    }, ROTATE_MS);
  }

  /* --------------------------------------------------------------- events */
  function onCart(cart) {
    try {
      renderTitle(cart);
      // the theme repaints the header after its rebuild - reassert the count
      setTimeout(function () { renderTitle(cart); }, 700);
      var next = choose(cart);
      renderReward(cart);
      var changed = next.map(function (p) { return p.h; }).join(',') !==
                    list.map(function (p) { return p.h; }).join(',');
      list = next;
      if (changed || idx >= list.length) { idx = 0; sel = []; }
      renderSuggest();
      start();
    } catch (e) {
      // never let a suggestion bug break the shopper's cart
      if (rewardEl) rewardEl.hidden = true;
      if (suggestEl) suggestEl.hidden = true;
    }
  }
  function refresh() {
    fetch(theme.routes.cart, { credentials: 'same-origin' })          // already ends in .js
      .then(function (r) { return r.json(); })
      .then(onCart)
      .catch(function () {});
  }

  function addChosen(btn) {
    if (busy) return;
    var id = btn.getAttribute('data-variant');
    if (!id) return;
    busy = true;
    btn.closest('.nsg__card').classList.add('is-busy');
    fetch(theme.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        busy = false;
        manual = false;
        // let the theme rebuild its own line items, then we re-read the cart
        document.dispatchEvent(new CustomEvent('cart:build'));
        refresh();
      })
      .catch(function () {
        busy = false;
        renderSuggest();
      });
  }

  function mount() {
    rewardEl = document.getElementById('NiroleReward');
    suggestEl = document.getElementById('NiroleSuggest');
    if (!rewardEl && !suggestEl) return;

    if (suggestEl) {
      suggestEl.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        // the drawer is a form and the theme binds clicks on it - stop this going anywhere
        e.preventDefault();
        e.stopPropagation();
        if (b.classList.contains('nsg__btn')) return addChosen(b);
        if (b.hasAttribute('data-dot')) {
          manual = true; stop();            // manual control wins for the session
          var n = Number(b.getAttribute('data-dot'));
          if (n !== idx) { idx = n; sel = []; renderSuggest(); }
        }
      });
      suggestEl.addEventListener('change', function (e) {
        var s = e.target.closest('select');
        if (!s) return;
        sel[Number(s.getAttribute('data-opt'))] = s.value;
        renderSuggest();                    // price follows the chosen variant
      });
    }

    var products = document.querySelector('#CartDrawer [data-products]');
    if (products && window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(refresh, 250);   // debounce the theme's own repaint
      }).observe(products, { childList: true, subtree: true });
    }

    document.addEventListener('cart:updated', function (e) {
      if (e.detail && e.detail.cart) onCart(e.detail.cart); else refresh();
    });
    document.addEventListener('cart:open', start);
    document.addEventListener('cart:close', stop);

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
